/* norgira-sculptor-search-collection-parity-2026-10-15 */
/* norgira-sculptor-search-collection-parity-fix-2026-10-15: hover/focus-only outline and real size values. */
(() => {
  if (window.__norgiraGridCardsReady) return;
  window.__norgiraGridCardsReady = true;
  const wishlistKey = 'norgira:wishlist:v1';
  const readWishlist = () => { try { const value = JSON.parse(localStorage.getItem(wishlistKey) || '[]'); return Array.isArray(value) ? value : []; } catch { return []; } };
  const writeWishlist = (items) => { const unique = [...new Set(items)]; localStorage.setItem(wishlistKey, JSON.stringify(unique)); window.dispatchEvent(new CustomEvent('norgira:wishlist-change', { detail: { handles: unique } })); };
  const parseVariants = (card) => { try { return JSON.parse(card.querySelector('[data-norgira-grid-variants]')?.textContent || '[]'); } catch { return []; } };
  const syncWishlist = () => {
    const active = new Set(readWishlist());
    document.querySelectorAll('[data-norgira-grid-card][data-product-handle]').forEach((card) => {
      const button = card.querySelector('[data-norgira-grid-wishlist]');
      if (!button) return;
      const selected = active.has(card.dataset.productHandle);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', selected ? 'Remove from Wishlist' : 'Add to Wishlist');
    });
  };
  const setupCard = (card) => {
    if (card.dataset.norgiraGridReady) return;
    card.dataset.norgiraGridReady = 'true';
    const sizeButtons = [...card.querySelectorAll('.norgira-grid-card__size')];
    const selectSize = (button) => {
      sizeButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      card.dataset.selectedSize = button.dataset.size || '';
    };
    const defaultSize = sizeButtons.find((button) => !button.disabled && button.dataset.size === 'S') || sizeButtons.find((button) => !button.disabled);
    if (defaultSize) selectSize(defaultSize);
    sizeButtons.forEach((button) => button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!button.disabled) selectSize(button);
    }));
    card.querySelector('[data-norgira-grid-wishlist]')?.addEventListener('click', (event) => {
      event.preventDefault(); event.stopPropagation();
      const values = readWishlist();
      const handle = card.dataset.productHandle;
      const index = values.indexOf(handle);
      if (index < 0) values.push(handle); else values.splice(index, 1);
      writeWishlist(values); syncWishlist();
    });
    card.querySelector('[data-norgira-grid-add]')?.addEventListener('click', async (event) => {
      event.preventDefault(); event.stopPropagation();
      const button = event.currentTarget;
      if (button.disabled) return;
      const selected = (card.dataset.selectedSize || '').toUpperCase();
      const variants = parseVariants(card);
      const sizePosition = Number(card.querySelector('[data-norgira-size-position]')?.dataset.norgiraSizePosition || 0) - 1;
      const variant = selected
        ? variants.find(item => item.available && (sizePosition >= 0 ? String(item.options?.[sizePosition]).toUpperCase() === selected : (item.options || []).some(option => String(option).toUpperCase() === selected)))
        : variants.find(item => item.available);
      if (!variant) { button.textContent = 'SOLD OUT'; return; }
      button.disabled = true; button.textContent = 'ADDING…'; button.setAttribute('aria-busy', 'true');
      let status = card.querySelector('[data-add-feedback]');
      if (!status) { status = document.createElement('span'); status.dataset.addFeedback = ''; status.setAttribute('role', 'status'); status.setAttribute('aria-live', 'polite'); status.style.cssText = 'display:block;font-size:10px;line-height:16px;text-align:center;color:#000'; button.insertAdjacentElement('afterend', status); }
      status.textContent = 'Adding to your cart…';
      try {
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender?.().map((section) => section.id) || ['cart-drawer', 'cart-icon-bubble'];
        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: 1 }], sections, sections_url: location.pathname }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Unable to add');
        button.textContent = 'ADDED ✓'; status.textContent = 'Added to your cart'; button.setAttribute('aria-busy', 'false');
        // Cart mutation has succeeded; a drawer rendering error must not invite a duplicate add.
        if (drawer?.renderContents) {
          try { drawer.classList.remove('is-empty'); drawer.renderContents(data); drawer.open?.(); }
          catch (error) { status.textContent = 'Added to your cart. Open Cart to view.'; }
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
      } catch (error) { button.textContent = 'TRY AGAIN'; status.textContent = 'Could not add. Please try again.'; button.setAttribute('aria-busy', 'false'); }
      window.setTimeout(() => { button.disabled = false; button.textContent = 'ADD TO CART'; status.textContent = ''; }, 3500);
    });
  };
  const setup = (root = document) => { root.querySelectorAll?.('[data-norgira-grid-card]').forEach(setupCard); syncWishlist(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setup()); else setup();
  document.addEventListener('shopify:section:load', (event) => setup(event.target));
  window.addEventListener('norgira:wishlist-change', syncWishlist);
  window.addEventListener('storage', (event) => { if (event.key === wishlistKey) syncWishlist(); });
  new MutationObserver((records) => { records.forEach((record) => record.addedNodes.forEach((node) => { if (node.nodeType === 1) setup(node); })); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* norgira-card-add-feedback-2026-10-15 */

/* norgira-card-add-feedback-2026-10-15 */


/* norgira-sculptor-collection-1to1-2026-10-15: independent card carousel controls. */
(() => {
  if (window.__norgiraGridCarouselReady) return;
  window.__norgiraGridCarouselReady = true;
  const setupCarousel = (root = document) => root.querySelectorAll?.('[data-norgira-grid-carousel]').forEach((carousel) => {
    if (carousel.dataset.norgiraCarouselReady) return;
    carousel.dataset.norgiraCarouselReady = 'true';
    const track = carousel.querySelector('[data-norgira-grid-track]');
    const slides = [...carousel.querySelectorAll('[data-norgira-grid-slide]')];
    const dots = [...carousel.querySelectorAll('[data-norgira-grid-dot]')];
    const previous = carousel.querySelector('[data-norgira-grid-prev]');
    const next = carousel.querySelector('[data-norgira-grid-next]');
    if (!track || slides.length < 2) return;
    let index = 0;
    const update = () => {
      track.style.transform = 'translateX(-' + (index * 100) + '%)';
      slides.forEach((slide, slideIndex) => { const active = slideIndex === index; slide.classList.toggle('is-active', active); slide.setAttribute('aria-hidden', String(!active)); slide.tabIndex = active ? 0 : -1; });
      dots.forEach((dot, dotIndex) => { const active = dotIndex === index; dot.classList.toggle('is-active', active); dot.setAttribute('aria-current', String(active)); });
      if (previous) previous.setAttribute('aria-disabled', String(index === 0));
      if (next) next.setAttribute('aria-disabled', String(index === slides.length - 1));
    };
    const move = (delta) => { index = Math.max(0, Math.min(index + delta, slides.length - 1)); update(); };
    previous?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); move(-1); });
    next?.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); move(1); });
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); index = dotIndex; update(); }));
    let touchX = null;
    carousel.addEventListener('touchstart', (event) => { touchX = event.touches[0]?.clientX ?? null; }, { passive: true });
    carousel.addEventListener('touchend', (event) => { if (touchX == null) return; const endX = event.changedTouches[0]?.clientX ?? touchX; const delta = endX - touchX; touchX = null; if (Math.abs(delta) >= 30) move(delta < 0 ? 1 : -1); }, { passive: true });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupCarousel()); else setupCarousel();
  document.addEventListener('shopify:section:load', (event) => setupCarousel(event.target));
  new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => { if (node.nodeType === 1) setupCarousel(node); }))).observe(document.documentElement, { childList: true, subtree: true });
})();
/* end norgira-sculptor-collection-1to1-2026-10-15 */

/* Reveal on finger contact, but never cancel the product link's native click. */
(() => {
  if (window.__norgiraGridCardContactReady) return;
  window.__norgiraGridCardContactReady = true;
  // Homepage, collections and search use one contact rule and one real-cart handler.
  const cardSelector = '[data-norgira-grid-card]';
  let contact = null;
  const touchLayout = () => innerWidth < 750 || matchMedia('(hover: none)').matches;
  const closeCards = (keep = null) => document.querySelectorAll(cardSelector + '.is-options-open').forEach((card) => {
    if (card !== keep && !card.closest('.nhp-related')) card.classList.remove('is-options-open');
  });
  const cancelContact = () => { closeCards(); contact = null; };
  const beginContact = (event, point) => {
    if (!touchLayout()) return;
    const target = event.target instanceof Element ? event.target : null;
    const card = target?.closest(cardSelector);
    if (!card) { cancelContact(); return; }
    // These rows reveal on finger contact and retain native first-click navigation.
    if (card.closest('.nhp-related')) return;
    if (target.closest('button,input,select,textarea,[role=button]')) return;
    const productImageLink = target.closest('[data-norgira-grid-slide],.norgira-product-card__image-link');
    if (!productImageLink || !point) return;
    closeCards(card);
    card.classList.add('is-options-open');
    contact = {x:point.clientX,y:point.clientY};
  };
  const moveContact = point => {
    if (contact && point && Math.hypot(point.clientX-contact.x,point.clientY-contact.y)>8) cancelContact();
  };
  document.addEventListener('touchstart', (event) => {
    if(event.touches.length!==1) { cancelContact(); return; }
    beginContact(event,event.touches[0]);
  }, {capture:true,passive:true});
  document.addEventListener('touchmove', event => moveContact(event.touches[0]), {capture:true,passive:true});
  document.addEventListener('touchend', () => { contact=null; }, {capture:true,passive:true});
  document.addEventListener('touchcancel', cancelContact, {capture:true,passive:true});
  document.addEventListener('pointerdown', event => { if(event.pointerType==='touch')beginContact(event,event); }, {capture:true,passive:true});
  document.addEventListener('pointermove', event => { if(event.pointerType==='touch')moveContact(event); }, {capture:true,passive:true});
  document.addEventListener('pointerup', event => { if(event.pointerType==='touch')contact=null; }, {capture:true,passive:true});
  document.addEventListener('pointercancel', event => { if(event.pointerType==='touch')cancelContact(); }, {capture:true,passive:true});
  document.addEventListener('scroll', cancelContact, {capture:true,passive:true});
  document.addEventListener('click', event => { if(!(event.target instanceof Element) || !event.target.closest(cardSelector))cancelContact(); }, true);
  addEventListener('resize', () => { if (!touchLayout()) closeCards(); }, { passive: true });
})();
/* end norgira-global-product-card-first-tap-2026-10-15 */
